import { HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CfgService } from '../../../../cfg/cfg.service';
import { ServerAddressesCfgService } from 'src/app/util/serverAddressesCfg.service';

export class OffersInNegotiation {
  public summaryEndpointPattern: string;
}

export class OffersInNegotiationKpiCfg {
  public offersInNegotiation: OffersInNegotiation;
}

@Injectable()
export class OffersInNegotiationKpiCfgService extends CfgService<OffersInNegotiationKpiCfg> {
  json: any = {
    offersInNegotiation: {
      summaryEndpointPattern: "%{DashboardApiUrl}/offers/{0}/innegotiation"
    }
  }

  constructor(httpBackend: HttpBackend, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  protected getCfgFile(): string {
    return `/cfg/kpi/offersInNegotiationKpi.cfg.json`;
  }

  /**
  * Carga las url en el json
  */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
